import React from 'react'
import Register from '../../components/Register'

function RegisterPage(props) {
	return (<Register />)
}

export default RegisterPage